/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Lessons_ConfirmInputs */

const en_lessons_confirm = /** @type {(inputs: Lessons_ConfirmInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Confirm`)
};

const he_lessons_confirm = /** @type {(inputs: Lessons_ConfirmInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`אישור`)
};

/**
* | output |
* | --- |
* | "Confirm" |
*
* @param {Lessons_ConfirmInputs} inputs
* @param {{ locale?: "en" | "he" }} options
* @returns {LocalizedString}
*/
export const lessons_confirm = /** @type {((inputs?: Lessons_ConfirmInputs, options?: { locale?: "en" | "he" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Lessons_ConfirmInputs, { locale?: "en" | "he" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "en") return en_lessons_confirm(inputs)
	return he_lessons_confirm(inputs)
});